<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px">
      <div class="title-font-style">
        <span>付款信息</span>
      </div>
      <el-form style="padding:10px 30px 0 30px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="付款类型：">客户提现</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款方式：">银行转账</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="提现金额：" label-width="70px">
              <el-input-number
                style="width:100%"
                v-model="queryParams.amount"
                :controls="false"
                :placeholder="'可提现金额：'+ queryParams.withdrawCash"
                :min="0"
                :max="queryParams.withdrawCash"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item label="备注：" label-width="70px">
              <el-input type="textarea" :rows="3" v-model="queryParams.mark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!------------ 账户信息 ------------>
    <customer-information :queryParams="queryParams" ref="customerInformationRefs"></customer-information>
    <div style="margin-left:20px">
      <el-button @click="onApplyForPayment" type="primary">申请付款</el-button>
    </div>
    <!------------ 申请付款 ------------>
    <open-or-close
      ref="OpenOrClose"
      @onUpdataState="onUpdataState"
      title="提现审核申请"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import customerInformation from './customerInformation'
import { queryAccountBankByCusId, financePay } from '@/api/sell/sellManage'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'customer-information': customerInformation
  },
  data () {
    return {
      isDetail: true,
      queryParams: {},
      params: {},
      content: '' // 二次申请付款确认弹窗内容
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      queryAccountBankByCusId(this.$route.query.cusId)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj
            this.queryParams.withdrawCash = this.queryParams.withdrawCash || 0
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 申请付款最终确认
    onUpdataState () {
      const obj = {
        receiptName: this.queryParams.suName,
        ...this.queryParams,
        ...this.params
      }
      if (this.$route.query.cwaId) {
        obj.id = this.$route.query.cwaId
      }
      financePay(obj)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('提现申请已提交，请等待审核！')
            this.$router.push({ name: 'customerWithdrawalRecord' })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 申请付款
    onApplyForPayment () {
      this.params = this.$refs.customerInformationRefs.obj
      this.queryParams.cbId = this.queryParams.cid
      this.queryParams.payMethod = 1
      if (!this.queryParams.amount) {
        this.$message.error('请输入提现金额！')
        return
      }
      if (!this.queryParams.mark) {
        this.$message.error('请填写备注！')
        return
      }
      if (!this.params.receiptOpenBank) {
        this.$message.error('开户行不可为空！')
        return
      }
      if (!this.params.receiptBankNumber) {
        this.$message.error('银行账号不可为空！')
        return
      }
      this.content = `本次提现金额总计：${this.queryParams.amount}元，确定提交提现申请？`
      this.$refs.OpenOrClose.onInitial()
    }
  }
}
</script>
